/*
 * Landings de Celovendo (secciones cv-*): copiar número de cuenta, video de
 * YouTube que solo se carga al hacer clic y resaltar el índice del texto largo.
 * Delegación de eventos en document, así funciona también con las secciones que
 * el editor de temas vuelve a dibujar.
 */
(function () {
  if (window.cvLanding) return;
  window.cvLanding = true;

  var COPY_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var CHECK_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if ((el.matches || el.msMatchesSelector).call(el, selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return ok;
  }

  function showCopied(btn) {
    btn.classList.add('is-copied');
    btn.innerHTML = CHECK_ICON + '<span>Copiado</span>';
    setTimeout(function () {
      btn.classList.remove('is-copied');
      btn.innerHTML = COPY_ICON + '<span>Copiar</span>';
    }, 2000);
  }

  function copy(btn) {
    var text = btn.getAttribute('data-cvl-copy');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { showCopied(btn); }, function () {
        if (fallbackCopy(text)) showCopied(btn);
      });
    } else if (fallbackCopy(text)) {
      showCopied(btn);
    }
  }

  function playVideo(btn) {
    var id = btn.getAttribute('data-cvl-yt');
    if (!id || btn.querySelector('iframe')) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = btn.getAttribute('aria-label') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    btn.appendChild(iframe);
  }

  document.addEventListener('click', function (e) {
    var copyBtn = closest(e.target, '[data-cvl-copy]');
    if (copyBtn) { e.preventDefault(); copy(copyBtn); return; }
    var video = closest(e.target, '[data-cvl-yt]');
    if (video) { e.preventDefault(); playVideo(video); }
  });

  // Índice: marca el título que se está leyendo.
  function initToc() {
    if (!('IntersectionObserver' in window)) return;
    var tocs = document.querySelectorAll('[data-cvl-toc]');
    for (var t = 0; t < tocs.length; t++) {
      (function (toc) {
        if (toc.getAttribute('data-cvl-toc-ready')) return;
        toc.setAttribute('data-cvl-toc-ready', '1');
        var links = toc.querySelectorAll('a[href^="#"]');
        var byId = {};
        var targets = [];
        for (var i = 0; i < links.length; i++) {
          var id = links[i].getAttribute('href').slice(1);
          var target = document.getElementById(id);
          if (target) { byId[id] = links[i]; targets.push(target); }
        }
        var observer = new IntersectionObserver(function (entries) {
          for (var j = 0; j < entries.length; j++) {
            if (!entries[j].isIntersecting) continue;
            for (var k = 0; k < links.length; k++) links[k].classList.remove('is-active');
            var link = byId[entries[j].target.id];
            if (link) link.classList.add('is-active');
          }
        }, { rootMargin: '-110px 0px -65% 0px' });
        for (var n = 0; n < targets.length; n++) observer.observe(targets[n]);
      })(tocs[t]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initToc);
  else initToc();
  document.addEventListener('shopify:section:load', initToc);
})();
